<!-- Iterate over the connected family members array, displaying the connected family members -->
<div class="bulb-connected-familymember-container hide-for-small-only">
  <h1 class="bulb-connected-familymember-title" transloco="parentAccounts.myStudents">My Students</h1>
  <family-divider></family-divider>
  <div *ngFor="let member of familyMembers">
    <base-container [member]="member" [containerType]="blockType">
    </base-container>
  </div>
  <div class="bulb-connected-students-add-student">
    <a (click)="scrollToAnchor('bulb-familyView-anchor')">
      <p>+ <span transloco="parentAccounts.addStudent.zeroState.label">Add Student</span></p>
    </a>
  </div>
</div>
